﻿import { connect } from 'react-redux';

const ProgressBar = ({ ...props }) => {

    const progress = props.currentProgress

    return (
        <div className='progress-bar'>
            <Range progress={progress} />
        </div>       
    )
}

const Range = ({ ...props }) => {
    return (
        // render current the filled range of progress bar along its width
        <div className='filler' style={{ width: `${props.progress}%` }} />
    );
};


// state

const mapStateToProps = (state) => {
    return {
        currentProgress: state.pensionWizardProgress.currentProgress
    };
};

export default connect(mapStateToProps, null)(ProgressBar);

